import { AIConvoChat } from '@modules/ai-convo/models/ai-convo-chat.model';
import {
    createFeatureSelector,
    createSelector,
    MemoizedSelector,
} from '@ngrx/store';
import { AIConvoState, AIConvoStateFeatureKey } from './ai-convo.reducer';

export const selectAIConvoFeature = createFeatureSelector<AIConvoState>(
    AIConvoStateFeatureKey,
);

export const selectAIConvoContext = createSelector(
    selectAIConvoFeature,
    (state) => state.context,
);

export const selectAIConvoPendingAttachment = createSelector(
    selectAIConvoFeature,
    (state) => state.pendingAttachment?.attachment ?? null,
);

export const selectAIConvoPendingReference = createSelector(
    selectAIConvoFeature,
    (state) => state.pendingReference,
);

export const selectAIConvoPendingAttachmentSource = createSelector(
    selectAIConvoFeature,
    (state) => state.pendingAttachment?.source ?? null,
);

export const selectActiveChatId = createSelector(
    selectAIConvoFeature,
    (state) => state.activeChatId,
);

export const selectActiveAIConvoChat = createSelector(
    selectAIConvoFeature,
    (state): AIConvoChat | null => state.chats[state.activeChatId] ?? null,
);

export const selectAIChatById = (
    chatId: string,
): MemoizedSelector<object, AIConvoChat | null> =>
    createSelector(
        selectAIConvoFeature,
        (state): AIConvoChat | null => state.chats[chatId] ?? null,
    );

export const selectAICommunityFilter = createSelector(
    selectAIConvoFeature,
    (state) => state.communityFilter,
);

export const selectAICommunityFilterMode = createSelector(
    selectAIConvoFeature,
    (state) => state.communityFilterMode,
);

export const selectAIConvoAgents = createSelector(
    selectAIConvoFeature,
    (state) => state.agents,
);

export const selectAIConvoAgentsFetching = createSelector(
    selectAIConvoFeature,
    (state) => state.agentsFetching,
);

export const selectActiveAgentForChat = createSelector(
    selectActiveAIConvoChat,
    (chat) => chat?.activeAgent ?? null,
);

export const selectAIConvoHistory = createSelector(
    selectAIConvoFeature,
    (state) => state.history,
);
